import { format } from 'timeago.js';

const numeral = require('numeral');

const TIMEOUT = 1;
const mixin = {
  data() {
    return {
      isEmpty: true,
      isFailing: false,
    };
  },
  methods: {
    numberFormat(number, stringFormat) {
      return numeral(number).format(stringFormat);
    },

    priceFormat(price) {
      return numeral(price).format('0,0.00');
    },

    setImageUrl(imageUrl) {
      // eslint-disable-next-line global-require
      return require(`@/Pretailer/assets/img/${imageUrl}`);
    },

    dateFormat(date) {
      return format(date);
    },

    capitalize(string) {
      if (typeof string !== 'string') return '';
      return string.toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },

    setBreadCrumbs(payload) {
      this.$store.commit('BreadCrumbs/setBreadCrumbs', payload);
    },

    formValidation(obj) {
      const errors = [];

      Object.keys(obj).forEach((item) => {
        if (obj[item] === '') {
          errors.push(item);
        }
      });

      return errors;
    },

    scrollTo(hashTag) {
      setTimeout(() => { location.href = hashTag; }, TIMEOUT);
    },

    validation(value, exceptions = []) {
      const errors = [];
      Object.keys(value).forEach((key) => {
        if (Array.isArray(value[key]) && value[key].length === 0) {
          console.log(key)
          errors.push(key);
        } else if ((!value[key] || value[key] === '') && !exceptions.includes(key)) {
          errors.push(key);
        }
      });

      return errors;
    },
  },

  mounted() {
    if (this.$route && this.$route.hash) {
      // setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT);
    }
  },
};


export default mixin;
